var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0362 13.7571H15.0362C15.4778 13.7558 15.901 13.5798 16.2133 13.2675C16.5255 12.9552 16.7016 12.5321 16.7029 12.0905V5.42379C16.7016 4.98217 16.5255 4.55901 16.2133 4.24673C15.901 3.93446 15.4778 3.75844 15.0362 3.75712H2.36955C1.92793 3.75844 1.50477 3.93446 1.19249 4.24673C0.880218 4.55901 0.7042 4.98217 0.702881 5.42379V12.0905C0.7042 12.5321 0.880218 12.9552 1.19249 13.2675C1.50477 13.5798 1.92793 13.7558 2.36955 13.7571H3.36955",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0229 8.42379H4.3829C3.82325 8.42379 3.36957 8.87747 3.36957 9.43712V16.0771C3.36957 16.6368 3.82325 17.0905 4.3829 17.0905H13.0229C13.5826 17.0905 14.0362 16.6368 14.0362 16.0771V9.43712C14.0362 8.87747 13.5826 8.42379 13.0229 8.42379Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0362 3.75712V2.75712C14.0349 2.3155 13.8589 1.89234 13.5466 1.58007C13.2343 1.26779 12.8112 1.09177 12.3696 1.09045H5.03623C4.59461 1.09177 4.17146 1.26779 3.85918 1.58007C3.54691 1.89234 3.37089 2.3155 3.36957 2.75712V3.75712",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3696 7.09045C14.9219 7.09045 15.3696 6.64274 15.3696 6.09045C15.3696 5.53817 14.9219 5.09045 14.3696 5.09045C13.8173 5.09045 13.3696 5.53817 13.3696 6.09045C13.3696 6.64274 13.8173 7.09045 14.3696 7.09045Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.e4c1c5437510fee936caaaa43aab6127.svg";
export { ForwardRef as ReactComponent };